import partial from 'lodash/partial'
import PropTypes from 'prop-types'
import React from 'react'
import {connect} from 'react-redux'
import {createStructuredSelector} from 'reselect'

import * as pdpActions from '../../actions/productDetailPage'
import * as pdp from '../../store/productDetailPage'
import * as pane from '../../store/pane'
import {advancedPdpImageClicked} from '../../track/track'
import {fastlyImpolicyPDPdesktop, noDecorators} from '../../utils'

import Bullets from './Bullets'
import CarouselWrapper from '../CarouselWrapper'
import LazyLoadImage from '../LazyLoad/LazyLoadImage'
import LeftArrow from './LeftArrow'
import RightArrow from './RightArrow'
import Svg from '../Svg'

import zoomIn from '../../../../svg/zoomin.svg'

const PdpCarousel = ({
  currentZoomIndex,
  displayedProduct,
  isDesktop,
  productId,
  productImages,
  productName,
  openZoomModal,
  onSlideChange,
}) => {
  const hasMoreThanOneImage = displayedProduct && productImages.length > 1

  const getCarouselControlsConfig = () => {
    const fireAvancedPdpImageEvent = partial(
      advancedPdpImageClicked,
      currentZoomIndex,
      productName,
      productId,
      'carousel',
    )

    return {
      ...noDecorators,
      ...{
        renderCenterLeftControls: (carouselProps) => (
          <LeftArrow {...carouselProps} trackingCall={fireAvancedPdpImageEvent} />
        ),
        renderCenterRightControls: (carouselProps) => (
          <RightArrow {...carouselProps} trackingCall={fireAvancedPdpImageEvent} />
        ),
        renderBottomCenterControls: (carouselProps) => (
          <Bullets {...carouselProps} modifier="pdp" trackingCall={fireAvancedPdpImageEvent} />
        ),
      },
    }
  }

  // TODO: Separate into new component.
  const renderZoomSvg = () => {
    const analyticsPayload = {
      productName,
      productId,
      photoIndex: currentZoomIndex,
    }
    const handleClick = () => {
      window.analytics.track('Initiated Zoom', analyticsPayload)
      openZoomModal()
    }
    return (
      <button className="zoom-in-button" onClick={handleClick} type="button">
        <Svg className="zoom-in-svg" src={zoomIn} />
      </button>
    )
  }

  if (!displayedProduct) {
    return null
  }

  return (
    <div className="product-image-container">
      {renderZoomSvg()}
      <CarouselWrapper
        afterSlide={onSlideChange}
        dragging={!isDesktop && hasMoreThanOneImage}
        slideIndex={currentZoomIndex}
        swiping={hasMoreThanOneImage}
        {...(hasMoreThanOneImage ? getCarouselControlsConfig() : noDecorators)}
      >
        {productImages.map(({name, url}) => (
          <figure className="o-frame o-frame--pdp" key={url}>
            <div className="o-frame__canvas">
              <LazyLoadImage
                className="o-frame__media"
                alt={name}
                key={url}
                src={`${url}${fastlyImpolicyPDPdesktop}`}
              />
            </div>
          </figure>
        ))}
      </CarouselWrapper>
    </div>
  )
}

PdpCarousel.propTypes = {
  currentZoomIndex: PropTypes.number,
  displayedProduct: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({})]),
  onSlideChange: PropTypes.func.isRequired,
  openZoomModal: PropTypes.func.isRequired,
  productId: PropTypes.string.isRequired,
  productImages: PropTypes.arrayOf(PropTypes.shape({})),
  productName: PropTypes.string.isRequired,
  isDesktop: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  currentZoomIndex: pdp.currentZoomImageIndex,
  displayedProduct: pdp.product,
  isDesktop: pane.windowIsDesktop,
  productId: pdp.productId,
  productImages: pdp.productAndModelImages,
  productName: pdp.productName,
})

const mapDispatchToProps = {
  onSlideChange: pdpActions.selectZoomThumbnail,
  openZoomModal: pdpActions.openZoomModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(PdpCarousel)
